import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import {Button, Modal, Form } from 'react-bootstrap';

import { toast } from 'react-toastify'

import Dialog from '../../services/Dialogs'

const ModalNuevoReporte = ( params : any ) => {

const dialog = new Dialog();


  const user = AuthService.getCurrentUser()

  const { show, handleClose } = params


  const [ boutique_reporte, setBoutiqueReporte ]  = useState<any>(null)

  const [ boutiques, setBoutiques ] = useState<any>([])
  const cargarBoutiques = async()=>{
    try{
      
      let response : any = await RequestService.getEndPoint(`lista/boutiques`)
      setBoutiques(response.data)
    }
    catch(e){
      toast.error('Problemas al intentar cargar')
    }
  }


  React.useEffect(() => {
    cargarBoutiques()
  }, []);

  const [ envio_server, setSeEnvio ] = useState<boolean>(false)

  const [ reporte_supervision, setReporteSupervision ] = useState<any>({ observaciones : "", areas : [{ lista_caminata_supervision : [], area: null }] })
  const cargarReporteCheck = async(uuid_boutique:string)=>{
    try{
      setSeEnvio(true)
      let response : any = await RequestService.getEndPoint(`reporte_visitas_supervision/${uuid_boutique}`)
      let reporte : any = {
        observaciones : "",
        areas : []
      }
      for(let area of response.data){
        reporte.areas.push({
          area : area.area,
          observaciones : "",
          lista_caminata_supervision : area.lista_caminata_supervision.map((lista:any)=>{ return { calificacion : "", descripcion : lista, observaciones : "" } })
        })

      }
      setReporteSupervision(reporte)
      setSeEnvio(false)
    }
    catch(e){
      setSeEnvio(false)
      toast.error('Problemas al intentar cargar')
    }
  }


const guardarReporte = async (event:any) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ``
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.create( `reporte_supervision/crear_reporte/${boutique_reporte}` , { reporte_supervision : reporte_supervision })

        if(res_){
          toast.success('El reporte fue guardado correctamente')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}




    


    
  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Nuevo Reporte</Modal.Title>
        </Modal.Header>
        <Modal.Body>


          <Form.Group className="mb-3" controlId="idboutique">
            <Form.Label>Boutique</Form.Label>
            <Form.Select required name="idboutique" value={boutique_reporte} onChange={(e)=>{ setBoutiqueReporte(  e.target.value ); cargarReporteCheck(e.target.value) }}  >
              <option value="">SELECCIONA UNA BOUTIQUE</option>
              {
                boutiques.map( (boutique:any) =>
                  <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                            <option value={boutique.uuid}> {boutique.nombre_boutique}</option>
                  </React.Fragment>
                )
              }
            </Form.Select>
          </Form.Group>



          {
            boutique_reporte === '' && (
                <p className="nm"><i className="fa fa-warning"/> Debes seleccionar una Boutique para reportar</p>
              )
          }

          {
            reporte_supervision.areas[0].area !== null && (
                <React.Fragment>
                  {
                    // JSON.stringify(reporte_supervision)
                  }


                              <div className="mt-2 mb-2">
                                <label className="form-label">Observaciones Generales</label>
                                <textarea className="form-control" rows={2} value={reporte_supervision.observaciones} onChange={(e:any)=>{ let r = {...reporte_supervision}; r.observaciones = e.target.value.toUpperCase(); setReporteSupervision(r) }}></textarea>
                              </div>



                  {
                    reporte_supervision.areas.map((area:any,indice_area:number)=>


                          <div key={indice_area} className="card">
                            <div className="card-header">
                              <h6 className="nm">{area.area}</h6>
                              <div className="mt-1">
                                <label className="form-label">Observaciones</label>
                                <textarea className="form-control" rows={2} value={area.observaciones} onChange={(e:any)=>{ let r = {...reporte_supervision}; r.areas[indice_area].observaciones = e.target.value.toUpperCase(); setReporteSupervision(r) }}></textarea>
                              </div>
                            </div>
                            <div className="card-body">
                              {
                                // JSON.stringify(area.lista_caminata_supervision)
                              }

                              {
                                area.lista_caminata_supervision.map((registro:any,indice_registro:number)=>
                                    <React.Fragment key={indice_registro}>
                                        <div className="mt-1">
                                          <label className="form-label">{registro.descripcion} </label>

                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" name={`inlineRadio3${indice_area}_${indice_registro}`} type="radio" id={`inlineRadio3${indice_area}_${indice_registro}`} checked={registro.calificacion==="BUENO"} onChange={(e:any)=>{ let r = {...reporte_supervision}; r.areas[indice_area].lista_caminata_supervision[indice_registro].calificacion = "BUENO"; setReporteSupervision(r) }} />
                                                  <label className="form-check-label delgadita" htmlFor={`inlineRadio3${indice_area}_${indice_registro}`}>BUENO</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" name={`inlineRadio2${indice_area}_${indice_registro}`} type="radio" id={`inlineRadio2${indice_area}_${indice_registro}`} checked={registro.calificacion==="REGULAR"} onChange={(e:any)=>{ let r = {...reporte_supervision}; r.areas[indice_area].lista_caminata_supervision[indice_registro].calificacion = "REGULAR"; setReporteSupervision(r) }} />
                                                  <label className="form-check-label delgadita" htmlFor={`inlineRadio2${indice_area}_${indice_registro}`}>REGULAR</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" name={`inlineRadio1${indice_area}_${indice_registro}`} type="radio" id={`inlineRadio1${indice_area}_${indice_registro}`} checked={registro.calificacion==="MALO"} onChange={(e:any)=>{ let r = {...reporte_supervision}; r.areas[indice_area].lista_caminata_supervision[indice_registro].calificacion = "MALO"; setReporteSupervision(r) }} />
                                                  <label className="form-check-label delgadita" htmlFor={`inlineRadio1${indice_area}_${indice_registro}`}>MALO</label>
                                                </div>

                                                <div className="mb-3" >
                                                  <label className="form-label">Observaciones</label>
                                                  <textarea className="form-control" rows={1} value={registro.observaciones} onChange={(e:any)=>{ let r = {...reporte_supervision}; r.areas[indice_area].lista_caminata_supervision[indice_registro].observaciones = e.target.value.toUpperCase(); setReporteSupervision(r) }}></textarea>
                                                </div>


                                        </div>
                                    </React.Fragment>
                                  )
                              }







                            </div>
                          </div>

                      )
                  }




                </React.Fragment>
              )
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" onClick={guardarReporte} type="button">Crear Reporte</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalNuevoReporte;